module.exports = "/assets/68778614608404172d12325f721949e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JV.png
// module id = 1524
// module chunks = 0